module.exports = __webpack_public_path__ + "img/project-yaenerg.6ff59c1a.png";